import { Box, Button, Card, Typography } from '@material-ui/core';
import { ErrorOutline, KeyboardArrowLeft } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(3, 2.5),
    textAlign: 'center',
  },
  icon: {
    fontSize: 40,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
  },
  studentName: {
    fontWeight: 'bold',
    wordBreak: 'break-word',
  },
}));

export function BlockedStep({ testInfo, onBack }) {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <ErrorOutline className={classes.icon} />
      <Typography variant="subtitle1" className={classes.studentName} gutterBottom>
        {testInfo?.studentName}
      </Typography>
      <Typography variant="body2" color="textSecondary" gutterBottom>
        {testInfo?.status === 'finished'
          ? 'Esta avaliação já teve o resultado lançado.'
          : 'Esta avaliação ainda não está disponível para correção.'}
      </Typography>
      <Box marginTop={2}>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<KeyboardArrowLeft />}
          onClick={onBack}
        >
          Buscar outro código
        </Button>
      </Box>
    </Card>
  );
}
